import { IconWrapper } from '../runtime';
export default IconWrapper('archive_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#E8B600"
    }
  }), h("path", {
    "attrs": {
      "d": "M2 16C0.895431 16 0 15.1046 0 14L16 14C16 15.1046 15.1046 16 14 16L2 16Z",
      "fill": "#DBAC00"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 16L8 14L16 14C16 15.1046 15.1046 16 14 16L8 16Z",
      "fill": "#F7C200"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8 1H6.00006L6 2H7.99994L8 1ZM8.00006 2H10L9.99994 3H8L8.00006 2ZM8 3L7.99994 4H6L6.00006 3H8ZM8.00006 4H10L9.99994 5H8L8.00006 4ZM8 5L7.99994 6H6L6.00006 5H8ZM8.00006 6H10L9.99994 7H8L8.00006 6ZM8 7L7.99994 7.99997H10V11H6V8V7.99997L6.00006 7H8ZM7 9.99997V8.99997H9V9.99997H7Z",
      "fill": "white"
    }
  })]);
});